import axios from 'axios';

const getProductInformation = (fiId: string, productMappingId: string): Promise<any> =>  {
    const getProductInformationUrl: string = '/api/rcx/config/' + fiId + '/product/product-mapping/' + productMappingId;
    return axios.get(getProductInformationUrl);
 }

export {
    getProductInformation,
}
